import moment from 'moment';
import { connect } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
//import { Upload } from './utils/Upload';
import {uploadBackend } from '../utils/Upload';
import _ from 'lodash';
import { AES } from 'crypto-js';
import {
    getReasonDD,
    getAssignTemplate,
    insertOffboardData,
    getOffboardDetailsById,
    updateIndividualTask,
    insertInitiateData,
    getTaskDetails,
    deleteTaskDetails,
    directoryHR,
    updateTaskStatus,
    updateTransitionPlan,
    manipulateIndividualOffboardTask,
    getIndividualTasks,
    getResponsiblePersonId,
} from '../service/DirectorAPI';
import { getReportingEmpId } from '../service/DirectorAPI';
import { getOffboadingTemplateTaskData } from '../service/adminApi';
import { directory } from '../service/PerformanceAPI';
import Select from 'react-select';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import Loader from '../StaticComponent/Loader';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';
import './Offboardcss/CSS/Concern-form.css';
import './Offboardcss/CSS/feedback.css';
import './Offboardcss/CSS/Goal-form.css';
import './Offboardcss/CSS/leave_request.css';
import './Offboardcss/CSS/leave-form.css';
import './Offboardcss/CSS/Leaveview.css';
import './Offboardcss/CSS/Offboarding-popup.css';
import './Offboardcss/CSS/profile.css';
import './Offboardcss/CSS/Transition-plan.css';
import { getReasonType } from '../service/api';

import { NotificationTrigger, OnlyNumberSpecialChar } from '../../src/utils/RegHandling';
import { sendMail } from '../service/RecruiterApi';
import { getS3 } from '../utils/Download.js';


const Offboarding = ({ websocket }) => {
    let search = window.location.search;

    //To get the logged in person detailss
    const [role, setrole] = useState(encryptStorage.getItem('role'));
    const [loggedInempId, setloggedInempId] = useState(encryptStorage.getItem('employeeId'));
    const [oldTaskData, setTaskData] = useState();

    //To get the name and domain
    const [employeeName, setemployeeName] = useState('');
    const [employeeDomain, setemployeeDomain] = useState('');
    const [emp_id, setemp_id] = useState('');
    let employeeId = '';

    let id;
    let Mode = new URLSearchParams(search).get('mode');
    let teamMem = new URLSearchParams(search).get('IsTeamMember'); 
    let isProfile = new URLSearchParams(search).get('IsProfile');
    let way = new URLSearchParams(search).get('way');
    const empid = new URLSearchParams(search).get('emp_id');
    let offboarding_id = new URLSearchParams(search).get('offboarding_Id');
    // let initator_id = window.sessionStorage.setItem('employeeId');
    // let user_id = window.sessionStorage.setItem('userId');
    let offboardData = {
        inlineEditID: -1,
        reason: 0,
        reason_type: 0, //added reason_type
        comments: '',
        attachment: [],
        assignedTemplate: '0',
        hrInCharge: '',
        lastWorkingDate: '',
        status: 'Active',
        // reason_type_id: 0,
        hr_reason_type_id:0,
        hr_comment:''
    };

    let offboardDataOld = {
        inlineEditID: -1,
        reason: 0,
        reason_type: 0, //added reason_type
        comments: '',
        attachment: [],
        assignedTemplate: '0',
        hrInCharge: '',
        lastWorkingDate: '',
        status: 'Active',
        // reason_type_id: 0,
        hr_reason_type_id:0,
        hr_comment:''
    };
    const [offboardOld, setoffboardOld] = useState(offboardDataOld);
    const [offboard, setoffboard] = useState(offboardData);
    const attachment = useRef();
    const attachment1 = useRef(null);

    const [reasonValidation, setreasonValidation] = useState('');
    const [hrreasonValidation,sethrreasonValidation] = useState('');
    const [relivingValidation, setrelivingValidation] = useState('');
    // const [reason_typeeValidation, setreason_typeValidation] = useState(''); // added state variable for reason_type
    const [reasonDropDownReason, setreasonDropDownReason] = useState([]);
    const [commentsValidation, setcommentsValidation] = useState('');
    const [hrcomment, sethrcomment] = useState('');
    const [hrreasontypeid, sethrreasontypeid] = useState();
    const [lastDateValidation, setlastDateValidation] = useState('');
    const [hrInChargeValidation, sethrInChargeValidation] = useState('');
    const [assignTemplateValidation, setassignTemplateValidation] = useState('');
    const [attachmentValidation, setattachmentValidation] = useState('');
    const [attachmentValidationTrans, setattachmentValidationTrans] = useState('');

    const [errorMsgforTask, setErrorMsgforTask] = useState();
    const [flag, setFlag] = useState(true);

    const [arrDropDownReason, setarrDropDownReason] = useState([]);
    const [arrDropDownReasonType, setarrDropDownReasonType] = useState([]); // added for reason_type

    const [arrDropDownTemplate, setarrDropDownTemplate] = useState([]);
    const [deleteID, setdeleteID] = useState('');

    const [attachmentPopUp, setattachmentPopUp] = useState(true);
    const [ShowAllEmployee, setShowAllEmployee] = useState([]);
    const [showEmployee, setShowEmployee] = useState([]);
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [selectedPeopleList1, setSelectedPeopleList1] = useState([]);
    const [selectedPeopleListOld, setSelectedPeopleListOld] = useState([]);
    const [value, setValue] = useState(false);
    const [taskStatusVariable, settaskStatusVariable] = useState(false);
    const [templateName, setTemplateName] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [disabledCheck, setDisabledCheck] = useState(false);
    const navigate = useNavigate();
    const [hrManagerId, setHrManagerId] = useState([]);
    const [ManagerId, setManagerId] = useState('');
    const [inactiveTab, setInactiveTab] = useState(false);

    const [template, setTemplate] = useState(0);
    let notificationID = [];
    let uniqueNotifyId = [];

    const textarearef = useRef(null);

    let transitionData = {
        work_item: '',
        due_date: '',
        taskuser_id: 0,
        responsiblePerson: '',
        responsiblePersonId: '',
        task_status: '',
        template_id: '',
        offboarding_id: '',
        task_type: '',
        employeeId: '',
    };
    let transitiongetData = {
        hrInCharge: '',
        lastWorkingDate: '',
        status: '',
        work_item: '',
        due_date: '',
        taskuser_id: 0,
    };
    const [transition, settransition] = useState(transitiongetData);

    const [gettransition, setgettransition] = useState([]);

    //transition
    const [successTemplate, setsuccessTemplate] = useState(0);
    const [transitionPopUp, settransitionPopUp] = useState(true);
    const [deletePopUp, setdeletePopUp] = useState(true);
    const [dindex, setDIndex] = useState();
    const [taskGridBody, settaskGridBody] = useState([]);
    const [offboardingId, setoffboardingId] = useState(0);
    const [disableInitiate, setdisableInitiate] = useState(true);
    const [disableTickwrong, setdisableTickwrong] = useState(false);
    let [renderVariable, setRenderVariable] = useState(true);
    const [successTemplates, setsuccessTemplates] = useState(0);

    let popupData = {
        dueDate: 0,
        userName: '',
        templateName: '',
        responsiblePerson: '',
        taskId: 0,
        status: '',
        att: '',
    };
    const [popup, setpopup] = useState(popupData);
    const [activeVariable, setactiveVariable] = useState(false);
    const [attachmentState, setattachmentState] = useState('');
    const [drop, setDrop] = useState(true);
 

    useEffect(() => {
        
        Mode = new URLSearchParams(search).get('mode');
        LoadDataEditView();
        loadTaskData();
        loadOffboardForm();
        bind();
        LoadReasontype();
    }, [successTemplate, renderVariable, emp_id]);

    useEffect(() => {
        let isSame = _.isEqual(offboard, offboardOld);
        if (isSame && selectedPeopleList != selectedPeopleListOld) {
            setDisabledCheck(true);
        } else if (!isSame) {
            setDisabledCheck(false);
        }
    }, [offboard, offboardOld, disabledCheck, selectedPeopleList, selectedPeopleListOld]);

    /* 
    PC_PM_06 -PC_PM_15 if the successtemplate is defined then the getindividualTasks api gets triggered with
     local object object as parameter and returns the response. after the response is set the task item is gets binded.

    */
    const getTemplateTask = async (val) => {
        let data = {
            template_id: val,
            offboarding_id: offboarding_id,
        };
       
        let response;
        if (successTemplate != 0) {
            response = await getIndividualTasks(data);
            response.data.ResponseData.sort((a, b) => a.taskuser_id - b.taskuser_id);
            setactiveVariable(toCheckStatus(response.data.ResponseData));
            
        } else {
            response = await getOffboadingTemplateTaskData(data);
          
        }

        if (successTemplate != 0) {
            if (response.data.statusCode === 200) {
                settaskGridBody(response.data.ResponseData);
                setgettransition(response.data.ResponseData);
                setDrop(toCheckStatus2(response.data.ResponseData));
                setIsLoading(true);
               
                let arr = [];
                let errarray = [];

                for (let i = 0; i < response.data.ResponseData.length; i++) {
                    // setErrorMsgforTask({ ...errorMsgforTask, [i]: errorMessage });
                    // transitionData = {
                    //     hrInCharge: '',
                    //     lastWorkingDate: '',
                    //     status: '',
                    //     work_item: response.data.ResponseData[i].task_name,
                    //     due_date: '',
                    //     taskuser_id: 0,
                    //     responsiblePerson: '',
                    // };
                    let errorMessage;
                    if (successTemplate == 0) {
                        errorMessage = {
                            id: i,
                            dueDate: '',
                            responsiblePerson: '',
                            workItem: '',
                            actionItem: false,
                            editItem: false,
                            editclickItem: false,
                        };
                    } else {
                        errorMessage = {
                            id: i,
                            dueDate: '',
                            responsiblePerson: '',
                            workItem: '',
                            actionItem: true,
                            editItem: true,
                            editclickItem: false,
                        };
                    }
                    if (successTemplate == 0) {
                        transitionData = {
                            work_item: response.data.ResponseData[i].task_name,
                            due_date: '',
                            taskuser_id: 0,
                            responsiblePerson: '',
                            responsiblePersonId: '',
                            task_status: 'InComplete',
                            template_id: 0,
                            offboarding_id: new URLSearchParams(search).get('offboarding_Id'),
                            task_type: response.data.ResponseData[i].task_id,
                            employeeId: new URLSearchParams(search).get('emp_id'),
                        };
                    } else {
                        let arr = [];
                        let due = moment(response.data.ResponseData[i].due_date).format('YYYY-MM-DD');
                       
                        let resPersonId = response.data.ResponseData[i].res_emp_name;
                        let PARSEvALUE = resPersonId;
                        arr.push(resPersonId);
                        //   let resPersonId = response.data.ResponseData[i].res_emp_name;
                      
                        transitionData = {
                            work_item: response.data.ResponseData[i].work_item,
                            due_date: due,
                            taskuser_id: response.data.ResponseData[i].taskuser_id,
                            responsiblePerson: arr,
                            responsiblePersonId: response.data.ResponseData[i].res_emp_id,
                            task_status: response.data.ResponseData[i].res_emp_id,
                            template_id: response.data.ResponseData[i].taskuser_id,
                            offboarding_id: response.data.ResponseData[i].offboading_id,
                            task_type: response.data.ResponseData[i].task_type,
                            employeeId: response.data.ResponseData[i].emp_id,
                        };
                    }
                   
                    errarray.push(errorMessage);

                    // setgettransition({...gettransition,[i]:transitionData})

                    arr.push(transitionData);
                }
                setgettransition(arr);
               
                setErrorMsgforTask(errarray);
            }
        } else {
            if (response.data.statusCode === 200) {
                settaskGridBody(response.data.data);

                
                let arr = [];

                let errarray = [];

                for (let i = 0; i < response.data.data.length; i++) {

                    // setErrorMsgforTask({ ...errorMsgforTask, [i]: errorMessage });

                    transitionData = {
                        hrInCharge: '',

                        lastWorkingDate: '',

                        status: '',

                        work_item: response.data.data[i].task_name,

                        due_date: '',

                        taskuser_id: 0,

                        responsiblePerson: '',
                    };

                    let errorMessage = {
                        id: i,

                        dueDate: '',

                        responsiblePerson: '',

                        workItem: '',

                        actionItem: false,

                        editItem: false,
                    };

                    transitionData = {
                        work_item: response.data.data[i].task_name,

                        due_date: '',

                        taskuser_id: 0,

                        responsiblePerson: '',

                        responsiblePersonId: '',

                        task_status: 'InComplete',

                        template_id: 0,

                        offboarding_id: new URLSearchParams(search).get('offboarding_Id'),

                        task_type: response.data.data[i].task_id,

                        employeeId: response.data.data[i].emp_id,
                    };

                    
                    errarray.push(errorMessage);

                    // setgettransition({...gettransition,[i]:transitionData})

                    arr.push(transitionData);
                }

                setgettransition(arr);


                setErrorMsgforTask(errarray);
            }
        }
    };

    const bind = async () => {
      
        let managersId = '';
        let empResult = await directory({});

        let samplearray = [];

        let temparray = empResult.data.ResponseData.emplist;

        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,

                img: '/Images/logo-person-user-person-icon.jpg',

                label: temparray[i].emp_name,

                username: temparray[i].emp_name,
            };

            samplearray.push(objresponse);
        }
        setShowAllEmployee(samplearray);
    };
    const loadOffboardForm = async () => {
       
         let response = await getReasonDD(empid);
        
         setarrDropDownReason(response.data.ResponseData[0]);
       
        let validReportTo = false;
        let req = {
            login_id: offboarding_id,
        };
if(Mode=='Edit')
        {
            response = await getResponsiblePersonId(req);
   
        
        response?.data.ResponseData?.map((value) => {
          
            if (encryptStorage.getItem('employeeId') == value.res_emp_id) {
                validReportTo = true;
            }
        })}
        

 
        switch (encryptStorage.getItem('groupid')) {
            case '1': {
                validReportTo = true;
                break;
            }
            case '2': {
                if (encryptStorage.getItem('employeeId') == empid) {
                    validReportTo = true;
                } else {
                    let request = {
                        login_id: encryptStorage.getItem('employeeId'),
                    };
                    let respdata = await getReportingEmpId(request);

              
                    for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                        if (respdata.data.ResponseData[0][i]?.emp_id === empid) {
                            validReportTo = true;
                        }
                        //
                    }
                }
                break;
            }
            case '3': {
                if (empid == encryptStorage.getItem('employeeId')) validReportTo = true;
                break;
            }
            default: {
                navigate('*');
                break;
            }
        }
        if (validReportTo) {
            setIsLoading(false);
            let response = await getReasonDD(empid);
            setarrDropDownReason(response.data.ResponseData[0]);
            let response1 = await getAssignTemplate();
            setarrDropDownTemplate(response1?.data);
            let HrID = response?.data?.ResponseData[4];
            let arr = [];
            // //debugger;
            
            HrID.map((obj) => {
                
                arr.push(obj.emp_id);
            });
            setHrManagerId(arr);

            //to get the hr
            let empResult;
            empResult = await directoryHR({});
            let samplearray = [];
            let temparray = empResult.data.ResponseData[0];
            for (let i = 0; i <= temparray.length - 1; i++) {
                let objresponse = {
                    value: temparray[i].emp_id,
                    label: temparray[i].emp_name,
                    username: temparray[i].emp_name,
                };
                samplearray.push(objresponse);
            }
            setShowEmployee(samplearray);
            setManagerId(response?.data?.ResponseData[5][0]?.reports_to);
           
            setIsLoading(true);
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    };
    const LoadDataEditView = async () => {
        if (Mode == 'Edit' || Mode == 'Trans') {
            offboarding_id = new URLSearchParams(search).get('offboarding_Id');
            setoffboardingId(new URLSearchParams(search).get('offboarding_Id'));
            selecteditarray(offboarding_id);
        } else if (Mode == 'View' || Mode == '' || Mode == undefined || Mode == true || Mode == null) {
            setemployeeName(new URLSearchParams(search).get('emp_name'));
            setemployeeDomain(new URLSearchParams(search).get('emp_domain'));
            setemp_id(new URLSearchParams(search).get('emp_id'));
            employeeId = new URLSearchParams(search).get('emp_id');
            if (role == 'Team Member' || loggedInempId == employeeId) {
                setoffboard({ ...offboard, reason: 3 });
            }
        }
    };

    const selecteditarray = async (offboarding_id) => {
        let validReportTo = false;
        let offData = {
            offboarding_id: offboarding_id,
        };
        setIsLoading(false);
        let responsedata = await getOffboardDetailsById(offData);
        const loggedInUserId = encryptStorage.getItem('employeeId')
        
        switch (encryptStorage.getItem('groupid')) {
            case '1':
                {
                    validReportTo = true;
                    break;
                }
            case '2':
                {
                    if (encryptStorage.getItem("employeeId") == responsedata.data.ResponseData[0][0].emp_id) {
                            validReportTo = true;

                    }
                    else {

                        let request = {
                            login_id: encryptStorage.getItem('employeeId'),
                        };
                         await getReportingEmpId(request).then((respdata)=>{

                        for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                            if (respdata.data.ResponseData[0][i]?.emp_id === responsedata.data.ResponseData[0][0].emp_id) {
                                validReportTo = true;
                            }
                            //
                        }})
                    }
                    break;
                }
            case '3':
                {
                    if (responsedata.data.ResponseData[0][0].emp_id == encryptStorage.getItem("employeeId"))
                        validReportTo = true;
                    break
                }
            default:
                {
                    navigate('*')
                    break;
                }

        }
        if(validReportTo){
        setemployeeDomain(responsedata.data.ResponseData[0][0]?.domain);
        setemployeeName(responsedata.data.ResponseData[0][0].emp_name);
        setemp_id(responsedata.data.ResponseData[0][0].emp_id);
        employeeId = responsedata.data.ResponseData[0][0].emp_id;
        setTemplateName(responsedata?.data?.ResponseData[0][0]?.templatename);

        let obj = {
            value: responsedata.data.ResponseData[0][0]?.hr_id || '',
            username: responsedata.data.ResponseData[0][0]?.hr_name || '',
            label: responsedata.data.ResponseData[0][0]?.hr_name || '',
        };

        setSelectedPeopleList([obj]);
        setSelectedPeopleListOld([obj]);
        let lastDate = moment(responsedata.data.ResponseData[0][0].last_working_date).format('YYYY-MM-DD');
        let valiDateobj = {
            reason: responsedata.data.ResponseData[0][0].reason_id,
            reason_type: responsedata.data.ResponseData[0][0].reason_type_id,
            comments: responsedata.data.ResponseData[0][0].comments,
            hr_reason_type_id: responsedata.data.ResponseData[0][0].hr_reason_type_id,
            hr_comment: responsedata.data.ResponseData[0][0].hr_comment,
            attachment: responsedata.data.ResponseData[0][0].attachments_url,
            assignedTemplate: responsedata.data.ResponseData[0][0].template_type || 0,
            lastWorkingDate: lastDate || '',
        };
        if (responsedata.data.ResponseData[0][0].offstatus == 'Completed') {
            valiDateobj.status = 'Inactive';
            setInactiveTab(true);
        } else {
            valiDateobj.status = 'Active';
        }
        setoffboard({ ...offboard, ...valiDateobj });
        setoffboardOld({ ...offboardOld, ...valiDateobj });
        if (responsedata.data.ResponseData[0][0].template_type == null) {
           
            setsuccessTemplate(0);
        } else {
            setsuccessTemplate(responsedata.data.ResponseData[0][0].template_type);
        }
        setIsLoading(true);
        }
            else {
            navigate('*', { state: { hideNav: false } })
        }
    };

    const offboardValidation = () => {
        if (offboard.reason == 0) {
            setrelivingValidation('Relieving Type is required');
        }
        if (offboard.reason_type == 0) {
            setreasonValidation('Reason for relieving is required');
        }
        if (offboard.comments.trim() == '') {
            setcommentsValidation('Comments is required');
        }
        if(Mode == 'Edit'){if (offboard.hr_reason_type_id== 0) {
            sethrreasonValidation('Exit for reason is required');
        }}
        // if(
        //     // Mode == 'Edit' && 
        //     offboard.hr_reason_type_id== 0) {
        //     sethrreasonValidation('Exit for reason is required');
        //     return false;
        // }
        if (offboard.comments != '' && OnlyNumberSpecialChar(offboard.comments)) {
            setcommentsValidation('Please enter a valid comments');
        }
        if (offboard.reason == 0 ||offboard.reason_type == 0 || offboard.comments == '' || (offboard.comments != '' && OnlyNumberSpecialChar(offboard.comments))) {
            return false;
        }
        if (attachmentValidation != '') {
            return false;
        }
        updateClicked();
    };

    const updateClicked = async () => {
        setIsLoading(false);
        const attachment1 = await fileUpload(attachment);
       
        let hrreason = (offboard.hr_reason_type_id?offboard.hr_reason_type_id:encryptStorage.getItem("exitbyreason"))
        let hrcomment;
        if(offboard.hr_comment){
            hrcomment=  offboard.hr_comment
        }
        else if(encryptStorage.getItem('hrcomment')){
            hrcomment= encryptStorage.getItem('hrcomment')
        }
        else{
            hrcomment=""
        }

        let offboardHRComments, offboardComments;
        let encrypted = AES.encrypt(hrcomment, "as-south");
        offboardHRComments = encrypted.toString();
        let encrypted2 = AES.encrypt(offboard.comments, "as-south");
        offboardComments = encrypted2.toString();
 
        let insertData = {
            emp_id: emp_id,
            status_id: 3,
            reason_id: parseInt(offboard.reason),
            reason_type_id: parseInt(offboard.reason_type), // added reason type id
           // reason_type_id: parseInt(offboard.reason_type),
            comments: offboardComments,
            attachments_url: attachment1,
            login_id: loggedInempId,
            hr_reason_type_id:hrreason==undefined?0:hrreason,
            hr_comment:offboardHRComments
        };
        let response = await insertOffboardData(insertData);

        setoffboardingId(response?.data.ResponseData[0][0]?.id);
       
        if (response.data.ResponseData[3][0]?.hr_incharge == response.data.ResponseData[3][0]?.reports_to) {
            notificationID.push(response.data.ResponseData[3][0]?.hr_incharge);
            await NotificationTrigger(
                {
                    title: 'Offboard',
                    message: `${employeeName} wants to initiate offboarding process`,
                    route: `/offboardingForm?emp_id=${empid}&offboarding_Id=${response.data.ResponseData[0][0]?.id}&mode=Edit`,
                    to_employee: response.data.ResponseData[3][0]?.hr_incharge,
                    by: loggedInempId,
                },
                uniqueNotifyId,
                websocket
            );
        }
        else {
            notificationID.push(response.data.ResponseData[3][0]?.hr_incharge);
            notificationID.push(response.data.ResponseData[3][0]?.reports_to);
        }
        if (hrManagerId.includes(ManagerId)) {
            
        }
        else {
            notificationID.push(...hrManagerId, ManagerId);
        }
        
        notificationID.map((data) => {
            if (loggedInempId != data) uniqueNotifyId.push(data);
        });

                //  hrManagerId?.map((data,i) => {
                //      if (data == ManagerId ) {
                //          uniqueNotifyId.splice(i,1);
                //      }
                //  });
        let NotifyIdDuplicate = [...new Set(uniqueNotifyId)];
        uniqueNotifyId = [...NotifyIdDuplicate];
        await NotificationTrigger(
            {
                title: 'Offboard',
                message: `${employeeName} wants to initiate offboarding process`,
                route: `/offboardingForm?emp_id=${empid}&offboarding_Id=${response.data.ResponseData[0][0]?.id}&mode=Edit`,
                to_employee: uniqueNotifyId,
                by: loggedInempId,
            },
            uniqueNotifyId,
            websocket
        );
        if (role != 'Team Member' && loggedInempId != emp_id) {
            await NotificationTrigger(
                {
                    title: 'Offboard',
                    message: `Your offboarding process has been initiated`,
                    route: `/offboardingForm?emp_id=${empid}&offboarding_Id=${response.data.ResponseData[0][0]?.id}&mode=Edit`,
                    to_employee: [emp_id],
                    by: loggedInempId,
                },
                emp_id,
                websocket
            );
        }

        let content = {
            Subject: `$ Leave Request - `,
            body: `

                    <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                    <h3 style="font-family:'Segoe UI'; ">Hi ,</h3> 
                    <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong> Leave</strong> request has been submitted for approval to <strong>.</strong>You will be notified on the approval status. </p>
                   <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
                   border-radius: 8px;">
                   <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/leaveform/"></a></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Working Days?</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">No. of Days (Weekend \Holidays)?</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Dependency Work and Responsible person</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason for Leave</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Alternate Contact Number</strong><span style="display: block;width: 45%;"></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px;  align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Availability in case of emergency</strong><span style="display: block;width: 45%;"></span></p>
                 
                   </div>
                  
                   
                  </div>


                   `,
            //  to: [email.teamMemberEmail],
            to: '',
            cc: '',

            //  from: 'hrcommunications@avasoft.com',
            from: '',
        };
        // sendMail(content);

        if (response.data.ErrorMessage == null) {
            if ((role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id) {
                setValue(true);
                document.body.scrollBottom = 0;
                document.documentElement.scrollBottom = 0;
            } else {
                encryptStorage.setItem('off', '1');
                if (teamMem == 'true')
                    window.location.href = `/profilecontainer?emp_id=${emp_id}&EmpId=${emp_id}&tab=Offboard&IsTeamMember=true`;
                else window.location.href = `/profilecontainer?EmpId=${emp_id}&tab=Offboard`;
            }
        }
        setIsLoading(true);
    };

    const fileUpload = async (attachment) => {
        let dirName = `${emp_id}-Offboarding `;
        let file = attachment.current.files[0];
        if (file != undefined) {
            let newFileName = attachment.current.files[0].name;
            let fileLocation = await uploadBackend(file, newFileName, dirName);
            return fileLocation;
        }
        return null;
    };
    //PC_PM02 -05 the loadTaskData function will call the gettemplatetask () inly if the successTemplate is defined.
    const loadTaskData = async () => {
        if (successTemplate != 0) {
            // let tempData = {
            //     template_id: successTemplate,
            //     offboarding_id: offboardingId,
            // };
            // setIsLoading(false);
            // let response = await getTaskDetails(tempData);
            // response.data.ResponseData.sort((a, b) => a.taskuser_id - b.taskuser_id);
            // settaskGridBody(response.data.ResponseData);
            // setactiveVariable(toCheckStatus(response.data.ResponseData));
            // setDrop(toCheckStatus2(response.data.ResponseData));
            // setIsLoading(true);
            getTemplateTask(successTemplate);
        } else {
            return false;
        }
    };

    const toCheckStatus = (data) => {
        const res = data.every((val) => val.task_status == 'Completed');
        if (res) return true;
        return false;
    };

    const toCheckStatus2 = (data) => {
        const res = data.every((val) => val.task_status == 'InComplete');
        if (res) return true;
        return false;
    };

    const buildReason = () => {
        return arrDropDownReason?.map((value, index) => {
            return <option value={value?.id}>{value?.relieving_type}</option>;
        });
    };

    const LoadReasontype = async () => {
        // let domainData = {};
        let responsedata = await getReasonType({});
        if (responsedata?.data) {
            setreasonDropDownReason(responsedata.data.result);
        }
    };

    const buildReasonType = () => {
        
        return reasonDropDownReason?.map((value, index) => {
            return <option value={value.id}>{value.reason_type}</option>;
        });
    };

    const buildTemplate = () => {
        if (arrDropDownTemplate.length != 0 && arrDropDownTemplate.length != undefined) {
            return arrDropDownTemplate.map((value, index) => {
                return (
                    <option key={index} value={value.id}>
                        {value.name}
                    </option>
                );
            });
        } else {
            return false;
        }
    };

    const OnValueChange = (e) => {
        if (e.target.name == 'reason') {
            setrelivingValidation('');
        }
        if (e.target.name == 'reason_type') {  // added for reason type
            setreasonValidation('');  
        }
        if (e.target.name == 'comments') {
            setcommentsValidation('');
        }
        if (e.target.name == 'hr_reason_type_id') {
            sethrreasontypeid(e.target.value)
        }
        if (e.target.name == 'hr_comment') {
            sethrcomment(e.target.value);
        }
        if (e.target.name == 'assignedTemplate') {
            setassignTemplateValidation('');
            
            setTemplate(e.target.value);
            setsuccessTemplates(e.target.value);
            getTemplateTask(e.target.value);
        }
        if (e.target.name == 'hrInCharge') {
            sethrInChargeValidation('');
        }
        if (e.target.name == 'lastWorkingDate') {
            setlastDateValidation('');
        }
        setoffboard({ ...offboard, [e.target.name]: e.target.value });
    };

    const OnTransitionChange = (e) => {
        settransition({ ...transition, [e.target.name]: e.target.value });
    };
    const OnEditTransitionChange = (e, i) => {
        let data = gettransition;
        data[i][e.target.name] = e.target.value;

        setgettransition(data);
        setFlag(!flag);
    };

    const editClicked = (e) => {
        let i = e.target.id.replace('edit', '');
        setoffboard({
            ...offboard,
            inlineEditID: i,
        });
        let date = moment(taskGridBody[i].due_date).format('YYYY-MM-DD');
        settransition({
            ...transition,
            work_item: taskGridBody[i].work_item,
            due_date: date,
            taskuser_id: taskGridBody[i].taskuser_id,
        });
        //setRenderVariable(!renderVariable);
    };
    const editClick = (e, index) => {
        bind();
        setdisableInitiate(true);
        // errorMessage['editItem'] = false;
        // let i = e.target.id.replace('edit', '');
        setoffboardOld(gettransition[index]);
        let errorMsg = errorMsgforTask;
        errorMsg[index]['editItem'] = false;
        errorMsg[index]['actionItem'] = false;
        errorMsg[index]['editclickItem'] = true;

        setErrorMsgforTask(errorMsg);

        // setErrorMsgforTask({ ...errorMsgforTask, [i]: errorMessage });

        // setgettransition({
        //         ...gettransition,
        //         inlineEditID: i,
        //     });
        //     let date = moment(gettransition[i].due_date).format('YYYY-MM-DD');
        //     setgettransition({
        //         ...gettransition,
        //         work_item: gettransition[i].work_item,
        //         due_date: date,
        //         taskuser_id: gettransition[i].taskuser_id,
        //     });
        //setRenderVariable(!renderVariable);
    };

    const ticketClicked = async (i) => {
        let insertData = {
            taskuser_id: transition[i].taskuser_id,
            work_item: transition[i].work_item,
            due_date: transition[i].due_date,
            responsiblePerson: transition[i].responsiblePerson,
        };
        setIsLoading(false);
        let response = await updateIndividualTask(insertData);
        setoffboard({
            ...offboard,
            inlineEditID: -1,
        });
        setRenderVariable(!renderVariable);
        setIsLoading(true);
    };

    const validate = async (i, val) => {
        let localObj = gettransition[i];
        let errorMsg = errorMsgforTask;

        let count = 0;
        console.log(errorMsg, 'errorMsg');

        if (localObj.due_date == '') {
            errorMsg[i]['dueDate'] = 'Enter Due Date';
            // errorMsg[i]=data

            count++;
        } else {
            errorMsg[i]['dueDate'] = '';
        }

        if (localObj.responsiblePerson == '') {
            errorMsg[i]['responsiblePerson'] = 'Enter responsible person';
            count++;
        } else {
            errorMsg[i]['responsiblePerson'] = '';
        }


        if (localObj.work_item == '') {
            errorMsg[i]['workItem'] = 'Enter work item';
            // errorMsg[i]=data

            // errorMsgforTask[i].workItem = 'Enter work item';
            count++;
        } else {
            errorMsg[i]['workItem'] = '';
        }

        setFlag(!flag);
        if (count != 0) {
            setErrorMsgforTask(errorMsg);
            return false;
        } else {
            errorMsg[i]['actionItem'] = true;
            errorMsg[i]['editItem'] = true;
            setErrorMsgforTask(errorMsg);
            let disbalenewData = [];
            for (let i = 0; i < taskGridBody.length; i++) {
                disbalenewData.push(errorMsg[i].actionItem);
            }
            if (disbalenewData.includes(false)) {
                setdisableInitiate(true);
            } else {
                setdisableInitiate(false);
            }
            if (val == 'insert') {
                let insertData = gettransition[i];
                insertData['template_id'] = successTemplates;
                insertData['manipulateType'] = 'insert';
                insertData['offboarding_id'] = offboardingId;
                let response = await manipulateIndividualOffboardTask(insertData);
                let taskgrid = gettransition;
                taskgrid[i]['taskuser_id'] = response.data.ResponseData[0].taskuser_id;
                setgettransition(taskgrid);
            } else {
                let insertData = gettransition[i];
                insertData['manipulateType'] = 'update';
                let response = await manipulateIndividualOffboardTask(insertData);
            }
            return true;
        }
    };
    const ticketsClicked = async (i, val) => {
        validate(i, val);
    };

    const deleteClicked = async (e, val, index) => {
        setdeletePopUp(false);

        let i = e.target.id.replace('delete', '');
        setdeleteID(parseInt(i));
    };
    const deleteInitiateClicked = async (index) => {
        setdeletePopUp(false);
        setDIndex(index);
        let i = gettransition[index]['taskuser_id'];

        setdeleteID(parseInt(i));
    };
    // const deleteClick = async (e) => {

    //     let i = e.target.id.replace('delete', '');
    //     setdeleteID(i);
    //       setdeletePopUp(false);
    // };

    const yesClicked = async () => {
        let data = {
            taskuser_id: deleteID,
        };
        setIsLoading(false);
        let response = await deleteTaskDetails(data);
        if (response.data.ErrorMessage == null) {
            if (!template) {
                setRenderVariable(!renderVariable);
            }
            setdeletePopUp(true);
        }
        if (template) {
            let array = gettransition;

            let arr = array.splice(dindex, 1);
            let updatedData = array;
            setgettransition(updatedData);

            let array1 = taskGridBody;
            let arr1 = array1.splice(dindex, 1);
            settaskGridBody(array1);

            setFlag(!flag);
        }
        setIsLoading(true);
    };

    const wrongClicked = () => {
        setoffboard({
            ...offboard,
            inlineEditID: -1,
        });
    };

    const wrongsClicked = (index) => {
        let errorMsg = errorMsgforTask;
        errorMsg[index]['actionItem'] = true;
        errorMsg[index]['editItem'] = true;
        setErrorMsgforTask(errorMsg);
        let disbalenewData = [];
        console.log(errorMsgforTask);
        for (let i = 0; i < taskGridBody.length; i++) {
            disbalenewData.push(errorMsg[i].actionItem);
        }
        if (disbalenewData.includes(false)) {
            setdisableInitiate(true);
        } else {
            setdisableInitiate(false);
        }
        //setgettransition({ ...gettransition, [index]: transitionData });
    };

    const getIndividualTask = (e, index) => {
        setattachmentValidationTrans('');

        taskGridBody.map((obj) => {
            if (obj.task_status == 'Completed') {
                settaskStatusVariable(true);
            }
        });
        let i = e.target.id;
        let taskData = taskGridBody[index];
        let dueDate = moment(taskData.due_date).format('MMMM DD,YYYY');
        let sts = taskData.task_status == 'InComplete' ? 'Completed' : 'InComplete';
        if (taskData.task_type == 1) setattachmentPopUp(false);
        else setattachmentPopUp(true);

        let attach;
        if (taskData.attachments_url == 'null') {
            attach = null;
            setattachmentState('');
        } else {
            attach = taskData.attachments_url;
        }
        setpopup({
            ...popup,
            dueDate: dueDate,
            templateName: taskData.work_item,
            responsiblePerson: taskData.res_emp_name,
            taskId: i,
            status: sts,
            att: attach,
        });
        settransitionPopUp(false);
    };
/* 
PC_PM_7.1 -7.4 
if the popup.status.tolowercase is completed then the notification trigger is called with the statement task is
  marked as completed else the statement will be marks as incompleted
*/

    const individualTaskUpdate = async () => {
        if (attachmentValidationTrans == '') {
            setIsLoading(false);
            const attachmentTask = await fileUpload(attachment1);
            let taskId = {
                taskuser_id: popup.taskId,
                task_status: popup.status,
                task_attachment: attachmentTask,
                offboarding_id: new URLSearchParams(search).get('offboarding_Id'),
                active: taskStatusVariable,
            };

            let response = await updateTaskStatus(taskId);
            // notificationID.push(response.data.)
            notificationID.push(response?.data.ResponseData[6][0]?.res_emp_id);
            notificationID.push(...hrManagerId, selectedPeopleList[0].value, emp_id, ManagerId);
            notificationID.map((data) => {
                     if (loggedInempId != data  ) uniqueNotifyId.push(data);
            });
            hrManagerId?.map((data,i) => {
                if (data == ManagerId) {
                    uniqueNotifyId.splice(i,1);
                }
            
            })
            let NotifyIdDuplicate = [...new Set(uniqueNotifyId)];
            uniqueNotifyId = [...NotifyIdDuplicate];
            if (popup.status.toLowerCase() == 'completed') {
                NotificationTrigger(
                    {
                        title: 'Offboard',
                        message: `Assigned task has been marked as Completed by  ${encryptStorage.getItem('username')}`,
                        route: `/offboardingForm?emp_id=${emp_id}&offboarding_Id=${offboardingId}&mode=Edit`,
                        to_employee: uniqueNotifyId,
                        by: loggedInempId,
                        state: {},
                    },
                    uniqueNotifyId,
                    websocket
                );
            } else {
                let res = await NotificationTrigger(
                    {
                        title: 'Offboard',
                        message: `Assigned task has been marked as InCompleted by  ${encryptStorage.getItem('username')}`,
                        route: `/offboardingForm?emp_id=${emp_id}&offboarding_Id=${offboardingId}&mode=Edit`,
                        to_employee: uniqueNotifyId,
                        by: loggedInempId,
                        state: {},
                    },
                    uniqueNotifyId,
                    websocket
                );
            }
            if (response.data.ErrorMessage == null) {
                settransitionPopUp(true);
            }
            setRenderVariable(!renderVariable);
            setIsLoading(true);
        }
    };

    const getTaskBody = () => {
        if (taskGridBody.length == 0) {
            return (
                <tr>
                    <td colSpan="10" className="accord-content1">
                        <div className="row justify-content-center">
                            <img src="Images/nodatafound.png" alt="nodatafound" className="nofeedbackimg-sty" />
                            <h2 className="tt-bold font-15 text-center">No Work items has been assigned</h2>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return taskGridBody.map((obj, index) => {
                let date = moment(obj.due_date).format('MMM DD,YYYY');
                if (offboard.inlineEditID != undefined && offboard.inlineEditID != -1 && offboard.inlineEditID == index) {
                    return (
                        <ul className="offboarding-tbody-backgrd shadow-sm list-unstyled d-flex align-items-center justify-content-between">
                            <li>
                                <input
                                    className="form-check-input custom-form-check-input cursor-pointer"
                                    style={{ 'margin-right': '10px' }}
                                    type="checkbox"
                                    checked={obj.task_status == 'Completed'}
                                    id={`${obj.taskuser_id}`}
                                    disabled={inactiveTab}
                                    onChange={(e) => getIndividualTask(e, index)}
                                />
                            </li>
                            <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">
                                <input
                                    type="email"
                                    className="form-control hive-form-control"
                                    id="hr-in-charge"
                                    aria-describedby="emailHelp"
                                    name="work_item"
                                    value={transition.work_item}
                                    onChange={(e) => OnTransitionChange(e)}
                                />
                            </li>
                            <li className="align-self-center medium-text list-unstyled font-12 offboarding-tbody-datecolor me-5 texthide-10 text-truncate">
                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    id="due_date"
                                    aria-describedby="emailHelp"
                                    name="due_date"
                                    value={transition.due_date}
                                    onChange={(e) => OnTransitionChange(e)}
                                />
                            </li>
                            <a className="align-self-center bold-text me-5 texthide-10 text-truncate">
                                <span>
                                    <img
                                        src="/Images/tick.svg"
                                        className="me-4 cursor-pointer"
                                        alt="icon"
                                        onClick={() => ticketClicked(index)}
                                        hidden={transition.due_date == '' || transition.work_item == '' ? true : false}
                                    />
                                </span>
                                <span>
                                    <img
                                        src="/Images/close.svg"
                                        className="iconspace cursor-pointer"
                                        alt="icon"
                                        onClick={() => wrongClicked(index)}
                                    />
                                </span>
                            </a>
                        </ul>
                    );
                } else {
                    return (
                        <ul className="offboarding-tbody-backgrd shadow-sm list-unstyled d-flex align-items-center justify-content-between">
                            <li>
                                <input
                                    className="form-check-input custom-form-check-input"
                                    id={`${obj.taskuser_id}`}
                                    checked={obj.task_status == 'Completed'}
                                    type="checkbox"
                                    disabled={inactiveTab}
                                    onChange={(e) => getIndividualTask(e, index)}
                                />
                            </li>
                            <li
                                className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate"
                                title={obj.work_item}
                            >
                                {transition.work_item}
                            </li>
                            <li className="align-self-center medium-text list-unstyled font-12 offboarding-tbody-datecolor me-5 texthide-10 text-truncate">
                                {date}
                            </li>
                            {obj.task_status != 'Completed' ? (
                                (role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id && inactiveTab == false ? (
                                    <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">
                                        {' '}
                                        <a>
                                            <button className="me-4" style={{ border: 'none', background: 'none' }}>
                                                <img
                                                    src="/Images/hive-edit-icon.svg"
                                                    className="cursor-pointer"
                                                    id={`edit${index}`}
                                                    alt="icon"
                                                    onClick={(e) => editClicked(e, index)}
                                                    disabled={role == 'Hr Manager' || role == 'Hr' ? false : true}
                                                />
                                            </button>
                                            <span
                                                className="ms-2"
                                                hidden={
                                                    ((role == 'Hr Manager' || role == 'Hr') && inactiveTab == false) || inactiveTab == false
                                                        ? false
                                                        : true
                                                }
                                            >
                                                <img
                                                    src="/Images/hive-delete-icon.svg"
                                                    className="iconspace cursor-pointer"
                                                    alt="icon"
                                                    id={`delete${obj.taskuser_id}`}
                                                    data-bs-toggle="modal"
                                                    onClick={(e) => deleteClicked(e)}
                                                />
                                            </span>
                                        </a>{' '}
                                    </li>
                                ) : (
                                    <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">
                                        {' '}
                                        <a>
                                            <button className="me-4" style={{ border: 'none', background: 'none' }}>
                                                <img
                                                    src="/Images/edit-disabled.svg"
                                                    id={`edit${index}`}
                                                    alt="icon"
                                                    disabled={
                                                        (role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id ? false : true
                                                    }
                                                />
                                            </button>
                                        </a>{' '}
                                    </li>
                                )
                            ) : (
                                <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">
                                    {' '}
                                    <a>
                                        <button className="me-4" style={{ border: 'none', background: 'none' }}>
                                            <img
                                                src="/Images/edit-disabled.svg"
                                                id={`edit${index}`}
                                                alt="icon"
                                                disabled={(role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id ? false : true}
                                            />
                                        </button>
                                    </a>{' '}
                                </li>
                            )}
                            {/* {((role == 'Hr Manager' || role == 'Hr')  && loggedInempId != emp_id ) && (inactiveTab == false)  ?
                                <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">  <a>
                                    <button className='me-4' style={{ border: "none", background: "none" }} >
                                        <img src="/Images/hive-edit-icon.svg" className="cursor-pointer" id={`edit${index}`} alt="icon" onClick={(e) => editClicked(e)} disabled={role == 'Hr Manager' || role == 'Hr' ? false : true}
                                        />
                                    </button>
                                    <span className="ms-2" hidden={((role == 'Hr Manager' || role == 'Hr') && inactiveTab == false)  || inactiveTab == false  ? false : true}>
                                        <img
                                            src="/Images/hive-delete-icon.svg"
                                            className="iconspace cursor-pointer"
                                            alt="icon"
                                            id={`delete${obj.taskuser_id}`}
                                            data-bs-toggle="modal"
                                            onClick={(e) => deleteClicked(e)}
                                        />
                                    </span>
                                </a> </li> :
                                <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">   <a>
                                    <button className='me-4' style={{ border: "none", background: "none" }} >
                                        <img src="/Images/edit-disabled.svg"  id={`edit${index}`} alt="icon"  disabled={(role == 'Hr Manager' || role == 'Hr' ) && loggedInempId != emp_id ? false : true}
                                        />
                                    </button>
                                </a> </li>} */}
                        </ul>
                    );
                }
            });
        }
    };
    const getTaskBodyInitiate = () => {
        if (taskGridBody.length == 0) {
            return (
                <tr>
                    <td colSpan="10" className="accord-content1">
                        <div className="row justify-content-center">
                            <img src="Images/nodatafound.png" alt="nodatafound" className="nofeedbackimg-sty" />
                            <h2 className="tt-bold font-15 text-center">No Work items has been assigned</h2>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return taskGridBody.map((obj, index) => {
                let date = moment(obj.due_date).format('MMM DD,YYYY');
                

                return (
                    <ul className="offboarding-tbody-backgrd shadow-sm list-unstyled d-flex align-items-center justify-content-between">
                        <li>
                            <input
                                className="form-check-input custom-form-check-input cursor-pointer"
                                style={{ 'margin-right': '10px' }}
                                type="checkbox"
                                checked={obj.task_status == 'Completed'}
                                id={`${obj.taskuser_id}`}
                                disabled={inactiveTab}
                                onChange={(e) => getIndividualTask(e, index)}
                            />
                        </li>
                        <li className="align-self-center bold-text list-unstyled font-12 offboarding-tboady-color me-5 texthide-10 text-truncate">
                            <input
                                type="email"
                                className="form-control hive-form-control"
                                id="hr-in-charge"
                                aria-describedby="emailHelp"
                                name="work_item"
                                value={gettransition[index]?.work_item}
                                disabled={errorMsgforTask[index]?.editItem}
                                onChange={(e) => OnEditTransitionChange(e, index)}
                            />
                            <span className="ErrorMsgform">{errorMsgforTask[index]?.workItem}</span>
                        </li>
                        <li className="align-self-center medium-text list-unstyled font-12 offboarding-tbody-datecolor me-5 texthide-10 text-truncate">
                            <input
                                type="date"
                                className="form-control hive-form-control"
                                id="due_date"
                                aria-describedby="emailHelp"
                                name="due_date"
                                // min={moment().subtract(0, "days").format("YYYY-MM-DD")}
                                value={gettransition[index]?.due_date}
                                disabled={errorMsgforTask[index]?.editItem}
                                onChange={(e) => OnEditTransitionChange(e, index)}
                            />
                            <span className="ErrorMsgform">{errorMsgforTask[index]?.dueDate}</span>
                        </li>
                        <div className="col-md-3">
                            <div className="mb-3 align-self-center" style={{ margin: '18px' }}>
                                <Select
                                    className="dropdown"
                                    name="touchbaseAttendees"
                                    maxMenuHeight={150}
                                    placeholder="Select"
                                    value={gettransition[index]?.responsiblePerson}
                                    options={ShowAllEmployee} // set list of the data
                                    onChange={(e) => {
                                        handleChanges(e, index);
                                    }} // assign onChange function
                                    isClearable
                                    isDisabled={errorMsgforTask[index]?.editItem}
                                    //isMulti
                                    // isDisabled={
                                    //     (role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id && inactiveTab == false
                                    //         ? false
                                    //         : true
                                    // }
                                />

                                <span className="ErrorMsgform">{errorMsgforTask[index]?.responsiblePerson}</span>
                            </div>
                        </div>
                        <a className="align-self-center bold-text me-5 texthide-10 text-truncate mx-4">
                        {role == 'Hr Manager' || role == 'Hr' ?( <span>
                                {!errorMsgforTask[index]?.actionItem ? (
                                    <>
                                        {errorMsgforTask[index]?.editclickItem ? (
                                            <>
                                                <img
                                                    src="/Images/tick.svg"
                                                    className="me-4 cursor-pointer"
                                                    alt="icon"
                                                    onClick={() => ticketsClicked(index, 'update')}
                                                />
                                                <img
                                                    src="/Images/close.svg"
                                                    className="iconspace cursor-pointer"
                                                    alt="icon"
                                                    onClick={() => wrongsClicked(index)}
                                                />
                                            </>
                                        ) : (
                                            <img
                                                src="/Images/tick.svg"
                                                className="me-4 cursor-pointer"
                                                alt="icon"
                                                onClick={() => ticketsClicked(index, 'insert')}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <button className="me-4" style={{ border: 'none', background: 'none' }}>
                                            <img
                                                src="/Images/hive-edit-icon.svg"
                                                className="cursor-pointer"
                                                id={`edit${index}`}
                                                alt="icon"
                                                onClick={(e) => editClick(e, index)}
                                                disabled={role == 'Hr Manager' || role == 'Hr' ? false : true}
                                            />
                                        </button>
                                        <span
                                            className="ms-2"
                                            hidden={
                                                ((role == 'Hr Manager' || role == 'Hr') && inactiveTab == false) || inactiveTab == false
                                                    ? false
                                                    : true
                                            }
                                        >
                                            <img
                                                src="/Images/hive-delete-icon.svg"
                                                className="iconspace cursor-pointer"
                                                alt="icon"
                                                id={`delete${gettransition[index]?.taskuser_id}`}
                                                data-bs-toggle="modal"
                                                onClick={(e) => deleteInitiateClicked(index)}
                                            />
                                        </span>
                                    </>
                                )}
                            </span>): <></>}
                        </a>
                    </ul>
                );
            });
        }
    };
/* 
PC_PM_1-11
In this function each input fileds are valided if the value no present then the error messages are stated here
if the data passed is save then saveclick() gets triggered.
*/
    const validationInitiate = (data) => {
        
        if (offboard.reason == 0) {
            setrelivingValidation('Relieving type is required');
        }
        if (offboard.reason_type == 0) {
            setreasonValidation('Reason type is required');
        }
        if (offboard.comments == '') {
            setcommentsValidation('Comments is required');
        }
        if (offboard.comments != '' && OnlyNumberSpecialChar(offboard.comments)) {
            setcommentsValidation('Please enter a valid comments');
        }
        if((data == 'save') && offboard.hr_reason_type_id == 0){
            // if(encryptStorage.getItem("exitbyreason")==''){
                sethrreasonValidation('Exit Reason is required');
                return false;
            // }
        }
        if((data == 'initiate') && Mode=='Edit' && offboard.hr_reason_type_id == 0){
                sethrreasonValidation('Exit Reason is required');
                return false;
        }
        if (attachmentValidation != '') {
            return false;
        }
        if (offboard.assignedTemplate == 0) {
            setassignTemplateValidation('Assign template is required');
        }
        if (selectedPeopleList[0] == null || selectedPeopleList[0].value == '') {
            sethrInChargeValidation('HR-in-charge is required');
        }
        if (offboard.lastWorkingDate == '' || offboard.lastWorkingDate == 'Invalid date') {
            setlastDateValidation('Last working date is required');
        }
        if (
            offboard.comments == '' ||
            (offboard.comments != '' && OnlyNumberSpecialChar(offboard.comments)) ||
            offboard.reason == 0 ||
            // offboard.reason_type == '' ||
            offboard.assignedTemplate == 0 ||
            selectedPeopleList[0] == null ||
            selectedPeopleList[0].value == '' ||
            offboard.lastWorkingDate == '' ||
            offboard.lastWorkingDate == null ||
            offboard.lastWorkingDate == 'Invalid date'
            // ||(Mode == 'Edit' && offboard.hr_reason_type_id == 0)
        ) {
            return false;
        }
        if (data == 'initiate') {
            initiateClicked();
        }
        if (data == 'save' && attachmentValidation == '') {
        
            saveClicked();
        }
    };
/*PC_PM_12-PC_PM_41
the api call is made to set the values based on the return employee id the notification trigger() gets called and the
respective notification is stored  against the respective employee. and the function will navigate to the sharepoint page.

*/
    const saveClicked = async () => {
        let temp = 0;
        if (successTemplate != offboard.assignedTemplate) temp = parseInt(offboard.assignedTemplate);
        let isSame = _.isEqual(offboard, offboardOld);
        if (!isSame || selectedPeopleList[0].value != selectedPeopleListOld[0].value) {
            let hrreason = (offboard.hr_reason_type_id?offboard.hr_reason_type_id:encryptStorage.getItem("exitbyreason"))
            if(hrreason == 0){
                sethrreasonValidation('Exit Reason is required')
                return false;
            }
            let hrcomment;
            if(offboard.hr_comment){
                hrcomment=  offboard.hr_comment
            }
            else if(encryptStorage.getItem('hrcomment')){
                hrcomment= encryptStorage.getItem('hrcomment')
            }
            else{
                hrcomment=""
            }
            let offboardHRComments, offboardComments;
            let encrypted = AES.encrypt(hrcomment, "as-south");
            offboardHRComments = encrypted.toString();
            let encrypted2 = AES.encrypt(offboard.comments, "as-south");
            offboardComments = encrypted2.toString();
     
                let insertData = {
                    offboarding_id: offboardingId,
                    emp_id: emp_id,
                    comments: offboardComments,
                    reason_id: parseInt(offboard.reason),
                    reason_type_id: parseInt(offboard.reason_type), // added for reason_type
                    hr_reason_type_id:hrreason,
                    hr_comment:offboardHRComments,
                    attachments_url: offboard.attachment,
                    last_working_date: offboard.lastWorkingDate,
                    assignedBy: loggedInempId,
                    hr: selectedPeopleList[0].value,
                    status: offboard.status,
                    active: activeVariable,
                    template_type: temp,
                };
            setIsLoading(false);

            let response = await updateTransitionPlan(insertData);
            encryptStorage.setItem("exitbyreason",0)
            encryptStorage.setItem("hrcomment",'');
            setIsLoading(true);
            notificationID.push(response?.data.ResponseData[6][0]?.res_emp_id);

            notificationID.push(...hrManagerId, selectedPeopleList[0].value, ManagerId);
            notificationID.map((data) => {
                if (loggedInempId != data) uniqueNotifyId.push(data);
            });
            let NotifyIdDuplicate = [...new Set(uniqueNotifyId)];
            uniqueNotifyId = [...NotifyIdDuplicate];
            // if (offboard.hr_reason_type_id == 0) {
            //     sethrreasonValidation('Exit Reason is required');
            // }
            if (offboard.status.toLowerCase() == 'active') {
                await NotificationTrigger(
                    {
                        title: 'Offboard',
                        message: `Transition plan for ${employeeName} has been updated`,
                        route: `/offboardingForm?emp_id=${empid}&offboarding_Id=${offboardingId}&mode=Edit`,
                        to_employee: uniqueNotifyId,
                        by: loggedInempId,
                        state: {},
                    },
                    uniqueNotifyId,
                    websocket
                );
                await NotificationTrigger(
                    {
                        title: 'Offboard',
                        message: `Transition plan for your offboarding process has been updated `,
                        route: `/offboardingForm?emp_id=${emp_id}&offboarding_Id=${offboardingId}&mode=Edit`,
                        to_employee: [emp_id],
                        by: loggedInempId,
                        state: {},
                    },
                    emp_id,
                    websocket
                );

                if (response.data.ErrorMessage == null) {
                    sessionStorage.setItem('off', '3');
                    if (teamMem == 'true') window.location.href = `/profilecontainer?EmpId=${empid}&tab=Offboard&IsTeamMember=true`;
                    else window.location.href = `/profilecontainer?EmpId=${empid}&tab=Offboard`;
                }
            }
            if (offboard.status.toLowerCase() == 'inactive') {
                await NotificationTrigger(
                    {
                        title: 'Offboard',
                        message: `Offboarding Completed for ${employeeName}`,
                        route: `/offboardingForm?emp_id=${emp_id}&offboarding_Id=${offboardingId}&mode=Edit`,
                        to_employee: uniqueNotifyId,
                        by: loggedInempId,
                        state: {},
                    },
                    uniqueNotifyId,
                    websocket
                );
                await NotificationTrigger(
                    {
                        title: 'Offboard',
                        message: `Your offboarding process has been completed`,
                        route: `/offboardingForm?emp_id=${empid}&offboarding_Id=${offboardingId}&mode=Edit`,
                        to_employee: [emp_id],
                        by: loggedInempId,
                        state: {},
                    },
                    emp_id,
                    websocket
                );

                if (response.data.ErrorMessage == null) {
                    sessionStorage.setItem('off', '4');
                    if (teamMem == 'true') {
                        window.open(
                            'https://avacorp1.sharepoint.com/sites/Infrastructure/Lists/Tickets/Open%20Tickets.aspx?skipSignal=true&viewid=01cb155e%2Ddec1%2D44da%2Db1d7%2D3f36604fec44&OR=Teams%2DHL&CT=1727357605617&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDA4MTcwMDQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D',
                            '_blank'
                        );
                        window.location.href = `/profilecontainer?EmpId=${emp_id}&tab=Offboard&IsTeamMember=true`;
                    } else {
                        window.open(
                            'https://avacorp1.sharepoint.com/sites/Infrastructure/Lists/Tickets/Open%20Tickets.aspx?skipSignal=true&viewid=01cb155e%2Ddec1%2D44da%2Db1d7%2D3f36604fec44&OR=Teams%2DHL&CT=1727357605617&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDA4MTcwMDQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D',
                            '_blank'
                        );

                        window.location.href = `/profilecontainer?EmpId=${emp_id}&tab=Offboard`;
                    }
                }
            }
        }
    };

    const initiateClicked = async () => {
        const attachment1 = await fileUpload(attachment);
        let hrreason = (offboard.hr_reason_type_id!==0?offboard.hr_reason_type_id:encryptStorage.getItem("exitbyreason"))
        let hrcomment;
        if(offboard.hr_comment){
            hrcomment=  offboard.hr_comment
        }
        else if(encryptStorage.getItem('hrcomment')){
            hrcomment= encryptStorage.getItem('hrcomment')
        }
        else{
            hrcomment=""
        }
        
        let offboardHRComments, offboardComments;
        let encrypted = AES.encrypt(hrcomment, "as-south");
        offboardHRComments = encrypted.toString();
        let encrypted2 = AES.encrypt(offboard.comments, "as-south");
        offboardComments = encrypted2.toString();
 
        let insertData = {
            offboarding_id: offboardingId,
            emp_id: emp_id,
            comments: offboardComments,
            reason_id: parseInt(offboard.reason),
            reason_type_id: parseInt(offboard.reason_type), // added for reason_type
            hr_reason_type_id:parseInt(hrreason),
            hr_comment:offboardHRComments,
            attachments_url: (attachment1 == null) ? offboard.attachment : attachment1,
            last_working_date: offboard.lastWorkingDate,
            assignedBy: loggedInempId,
            template_type: parseInt(offboard.assignedTemplate),
            hr: selectedPeopleList[0].value,
            status: offboard.status,
        };

        
        setIsLoading(false);
        let response = await insertInitiateData(insertData);
        notificationID.push(response.data.ResponseData[5][0]?.res_emp_id);
        notificationID.push(response.data.ResponseData[4][0]?.hr_incharge);
        notificationID.push(...hrManagerId, selectedPeopleList[0].value, ManagerId);
        if (hrManagerId.includes(ManagerId)) {
        } else {
            notificationID.push(...hrManagerId, ManagerId);
        }
        let uniqueNotificationId = [...new Set(notificationID)];
        notificationID = [...uniqueNotificationId]
        
        notificationID.map((data) => {
            if (loggedInempId != data) uniqueNotifyId.push(data);
        });

         hrManagerId?.map((data,i) => {
             if (data == ManagerId ) {
                 uniqueNotifyId.pop(data);
             }
         });
         let NotifyIdDuplicate = [...new Set(uniqueNotifyId)];
         uniqueNotifyId = [...NotifyIdDuplicate];
        await NotificationTrigger(
            {
                title: 'Offboard',
                message: `Transition plan for ${employeeName} has been assigned`,
                route: `/offboardingForm?emp_id=${emp_id}&offboarding_Id=${offboardingId}&mode=Edit`,
                to_employee: uniqueNotifyId,
                by: loggedInempId,
            },
            uniqueNotifyId,
            websocket
        );
        await NotificationTrigger(
            {
                title: 'Offboard',
                message: `Transition plan for your offboarding process has been assigned`,
                route: `/offboardingForm?emp_id=${emp_id}&offboarding_Id=${offboardingId}&mode=Edit`,
                to_employee: [emp_id],
                by: loggedInempId,
            },
            emp_id,
            websocket
        );
        if((response.status== 200) && (offboard.status == 'Inactive'))
            {
                if (teamMem == 'true') {
                    window.open(
                        'https://avacorp1.sharepoint.com/sites/Infrastructure/Lists/Tickets/Open%20Tickets.aspx?skipSignal=true&viewid=01cb155e%2Ddec1%2D44da%2Db1d7%2D3f36604fec44&OR=Teams%2DHL&CT=1727357605617&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDA4MTcwMDQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D',
                        '_blank'
                    );
                    window.location.href = `/profilecontainer?EmpId=${emp_id}&tab=Offboard&IsTeamMember=true`;
                } else {
                    window.open(
                        'https://avacorp1.sharepoint.com/sites/Infrastructure/Lists/Tickets/Open%20Tickets.aspx?skipSignal=true&viewid=01cb155e%2Ddec1%2D44da%2Db1d7%2D3f36604fec44&OR=Teams%2DHL&CT=1727357605617&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDA4MTcwMDQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D',
                        '_blank'
                    );

                    window.location.href = `/profilecontainer?EmpId=${emp_id}&tab=Offboard`;
                }
            }
        if (response) {
            sessionStorage.setItem('off', '2');
            if (teamMem == 'true') window.location.href = `/profilecontainer?EmpId=${emp_id}&tab=Offboard&IsTeamMember=true`;
            else window.location.href = `/profilecontainer?EmpId=${empid}&tab=Offboard`;
        }
    };

    const cancelClicked = () => {
        settransitionPopUp(true);
        setattachmentState('');
    };

    const cancelClickedDelete = () => {
        setdeletePopUp(true);
    };

    const handleChange = (e) => {
        sethrInChargeValidation('');
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        attend.push(e);
        setSelectedPeopleList(attend);

        setoffboard({ ...offboard, hrInCharge: attend[0].value });
    };
    const handleChanges = (e, i) => {
        sethrInChargeValidation('');
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        attend.push(e);
        setSelectedPeopleList1(attend);
        let data = gettransition;
        data[i]['responsiblePerson'] = attend;

        data[i]['responsiblePersonId'] = attend[0].value;

        // data[i]["responsiblePerson"]=attend[0].value
        setgettransition(data);

        // setgettransition({ ...gettransition, [i]: attend[0].value })
    };
    const bindAttachName = (e, value) => {
        setattachmentValidation('');
        setattachmentValidationTrans('');
        setattachmentState(e.target.files[0].name);
        if (value == 'off') {
            if (e.target.files[0].size >= 250000) {
                setattachmentValidation('File size should be less than 250KB');
                attachment1.current.value = '';
                attachment.current.value = '';
                return false;
            }
            const typeArr = ['pdf', 'doc', 'docx', 'txt'];
            let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
            if (type == false) {
                setattachmentValidation('The uploaded file should be in PDF or DOC format');
                attachment1.current.value = '';
                attachment.current.value = '';
                return false;
            }
        }
        if (value == 'trans') {
            if (e.target.files[0].size >= 250000) {
                setattachmentValidationTrans('File size should be less than 250KB');
                attachment1.current.value = '';
                attachment.current.value = '';
                return false;
            }
            const typeArr = ['pdf', 'doc', 'docx', 'txt'];
            let type = typeArr.includes(e.target.files[0].name.split('.')[1]);
            if (type == false) {
                setattachmentValidationTrans('The uploaded file should be in PDF or DOC format');
                attachment1.current.value = '';
                attachment.current.value = '';
                return false;
            }
        }
        setattachmentPopUp(true);
    };

    const removeAttachemnt = () => {
        setattachmentState('');
        setattachmentValidation('');
        setattachmentPopUp(false);
        setattachmentValidationTrans('');
        attachment1.current.value = '';
        attachment.current.value = '';
        popup.att = null;
        setpopup(popup);
        setRenderVariable(!renderVariable);
    };

    const bindAttachTrans = () => {
        if (popup.att != null) {
            let attachmentName = popup.att.substring(59);
            return (
                <span className="ms-4 " hidden={popup.att == '' ? true : false}>
                    <img className="me-2" src="/Images/attach-file.svg" alt="Upload Icon" />
                    <a href={popup.att}>{attachmentName}</a>
                    <a
                        className="cursor-pointer"
                        hidden={popup.att == '' ? true : false}
                        style={{ color: 'red' }}
                        onClick={() => removeAttachemnt()}
                    >
                        <u>Remove</u>
                    </a>
                </span>
            );
        } else if (popup.att == null && attachmentState == '') {
            let attachmentToolTipTrans = attachmentState.substring(0, 20);
            return (
                <span hidden={attachmentState ? false : true} data-bs-toggle="tooltip" data-bs-placement="top" title={attachmentState}>
                    <img className="me-2" src="/Images/attach-file.svg" alt="Upload Icon" />
                    {attachmentToolTipTrans}
                    <a className="cursor-pointer ms-2" style={{ color: 'red' }} onClick={() => removeAttachemnt()}>
                        <u>Remove</u>
                    </a>
                </span>
            );
        } else if (popup.att == null) {
            let attachmentToolTipTrans = attachmentState.substring(0, 20);
            return (
                <span hidden={attachmentState ? false : true} data-bs-toggle="tooltip" data-bs-placement="top" title={attachmentState}>
                    <img className="me-2" src="/Images/attach-file.svg" alt="Upload Icon" />
                    {attachmentToolTipTrans}
                    <a className="cursor-pointer ms-2" style={{ color: 'red' }} onClick={() => removeAttachemnt()}>
                        <u>Remove</u>
                    </a>
                </span>
            );
        }
    };

    const bindAttach = () => {
        if (Mode == 'Edit' || Mode == 'Trans') {
            if (offboard.attachment.length == 0 || offboard.attachment == 'null') {
                return (
                    <span
                        className="form-label hive-form-label w-100 font-12  ms-3"
                        hidden={Mode == '' || Mode == undefined || Mode == true || Mode == null ? true : false}
                    >
                        No Attachment Found
                    </span>
                );
            } else {
                let attachmentName = offboard.attachment.split('/').pop()
                return (
                    <span className="ms-4">
                        <img className="me-2" src="/Images/attach-file.svg" alt="Upload Icon" />
                        <a target="_blank"
                        
                        style={{ cursor: "pointer", color: "blue" }} onClick={async () => {

    window.open(await getS3(offboard.attachment), "_blank");
}} >
                            {attachmentName}
                        </a>
                    </span>
                );
            }
        } else {
            let attachmentToolTip = attachmentState.substring(0, 20);
            return (
                <span
                    hidden={attachmentState != '' ? false : true}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={attachmentState}
                >
                    <img className="me-2" src="/Images/attach-file.svg" alt="Upload Icon" />
                    {attachmentToolTip}
                    <a className="cursor-pointer ms-2" style={{ color: 'red' }} onClick={() => removeAttachemnt()}>
                        <u>Remove</u>
                    </a>
                </span>
            );
        }
    };
    let pathname;
    if (inactiveTab) pathname = `/profilecontainer?EmpId=${emp_id}&tab=Offboard&Status=Inactive`;
    else pathname = `/profilecontainer?EmpId=${emp_id}&tab=Offboard&Status=Active`;
    const cancelClickedOffboarding = () => {
        if (role == 'Team Member' || teamMem == 'true' || isProfile == 'true') {
            window.location.href = pathname;
        } else if ((Mode == '' || Mode == undefined || Mode == true || Mode == null || Mode == 'Trans') && role != 'Team Member') {
            window.location.href = pathname;
        } else if (Mode == 'Edit' && loggedInempId == emp_id) {
            window.location.href = pathname;
        } else if (Mode == 'View' && role != 'Team Member') {
            window.location.href = `/teamDirectory`;
        } else if (way == 'grid' || (Mode == 'Edit' && role != 'Team Member' && isProfile != 'true')) {
            window.location.href = `/HrOffboardingGrid`;
        } else if (Mode == 'Edit' && role == 'Team Member') {
            window.location.href = pathname;
        }
    };
    let breadCrumbsData;

    if (role === 'Team Member' || teamMem == 'true') {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/overview', isActive: true },
            { title: 'My Profile', path: pathname, isActive: true },
            { title: 'Offboarding from', path: '', isActive: false },
        ];
    } else if (loggedInempId == emp_id) {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'My Profile', path: pathname, isActive: true },
            { title: 'Offboarding from', path: '', isActive: false },
        ];
    } else if (way == 'grid' || (role !== 'Team Member' && Mode == 'Edit')) {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/overview', isActive: true },
            { title: 'Team Member', path: '', isActive: true },
            { title: 'Offboarding', path: '/HrOffboardingGrid', isActive: true },
            { title: 'Offboarding form', path: '', isActive: false },
        ];
    } else if (
        role != 'Team Member' &&
        (Mode == 'View' || Mode == '' || Mode == undefined || Mode == true || Mode == null || Mode == 'Trans')
    ) {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/overview', isActive: true },
            { title: 'Team Member', path: '', isActive: true },
            { title: 'Team Member Directory', path: '/teamdirectory', isActive: true },
            { title: employeeName, path: pathname, isActive: true },
            { title: 'Offboarding from', path: '', isActive: false },
        ];
    } else if (
        role != 'Team Member' &&
        teamMem == 'true' &&
        (Mode == '' || Mode == undefined || Mode == true || Mode == null || Mode == 'Trans')
    ) {
        breadCrumbsData = [
            { title: 'Dashboard', path: '/Overview', isActive: true },
            { title: 'My Profile', path: pathname, isActive: true },
            { title: 'Offboarding from', path: '', isActive: false },
        ];
    }
    let hrcomments="";
    if(offboard.hr_comment!=="undefined"&&offboard.hr_comment!==""&&offboard.hr_comment!==null){
        hrcomments=  offboard.hr_comment
    }
    else if(encryptStorage.getItem('hrcomment')!==undefined&&encryptStorage.getItem('hrcomment')!==""&&encryptStorage.getItem('hrcomment')!==null){
        hrcomments= encryptStorage.getItem('hrcomment')
    }
    else{
        hrcomments=""
    }

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid coverpic ">
                <div className="row justify-content-center mt-5">
                    {/*Form structure starts Here*/}
                    <div
                        className={
                            successTemplate != 0 || role == 'Hr' || role == 'Hr Manager'
                                ? 'col-md-8 p-4 mt-5 bg-white rounded-3'
                                : 'col-md-8 p-4 mt-5 bg-white rounded-3 mb-5'
                        }
                    >
                        <BreadCrumbs data={breadCrumbsData} />
                        <div className="modal-header border-0">
                            <h6 className="font-15 tt-bold offboarding-labelcolor">Offboarding Form</h6>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-4">
                                <div className="col-md-12 profile-spacing mb-4">
                                    <div className="profile-left d-flex">
                                        <div className="d-flex">
                                            <img
                                                src="/Images/logo-person-user-person-icon.jpg"
                                                alt="User Profile Image"
                                                className="profile-image-feedback"
                                            />
                                        </div>
                                        <div className="d-grid ms-3">
                                            <span className="font-12 mb-0 semibold-text offboarding-name-sty">{employeeName}</span>
                                            <span className=" font-12 pb-0 pt-1 regular-text my-0">{employeeDomain}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-4">
                                    <label htmlFor="bankdetails-name" className="form-label hive-form-label">
                                        Relieving Type<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="bankdetails-name"
                                        name="reason"
                                        value={offboard.reason}
                                        onChange={(e) => OnValueChange(e)}
                                        disabled={role == 'Team Member' || loggedInempId == emp_id ? true : Mode == 'Edit' ? true : false}
                                    >
                                        <option value={0}>Select</option>
                                        {buildReason()}
                                    </select>
                                    <span className="ErrorMsgform">{relivingValidation}</span>
                                    
                                </div>
                                <div className="col-md-4 mb-4">
                                    <label htmlFor="bankdetails-name" className="form-label hive-form-label">
                                        Reason for Relieving<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="bankdetails-name"
                                        name="reason_type"
                                        value={offboard.reason_type}
                                        onChange={(e) => OnValueChange(e)}
                                        // disabled={Mode == 'Edit' ? true : false}
                                        // disabled={
                                        //     (role == 'Hr Manager' || role == 'Hr') ||
                                        //     loggedInempId == emp_id ||
                                        //     inactiveTab == false
                                        //         ? false
                                        //         : true
                                        // }
                                        //disabled={role == 'Team Member' || loggedInempId == emp_id ? true : Mode == 'Edit' ? true : false}
                                    >
                                        <option value={0}>Select</option>
                                        {buildReasonType()}
                                    </select>
                                    <span className="ErrorMsgform">{reasonValidation}</span>
                                </div>

                                <div className="col-md-12 mb-4">
                                    <label htmlFor="Drop-your-comments" className="form-label hive-form-label">
                                        Comments<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <textarea
                                        ref={textarearef}
                                        onBlur={() => {
                                            textarearef.current.scrollTop = 0;
                                        }}
                                        className="form-control hive-form-control"
                                        id="Drop-your-comments"
                                        name="comments"
                                        value={offboard.comments}
                                        rows={5}
                                        maxLength={1000}
                                        onChange={(e) => OnValueChange(e)}
                                        placeholder="Enter the comments"
                                        disabled={Mode == 'Edit' ? true : false}
                                    />
                                    <span className="ErrorMsgform">{commentsValidation}</span>
                                </div>
                            </div>
                            <div>
                                <label className="form-label bold-text font-15 fontcolor-2 d-flex">
                                    Attachment{' '}
                                    <span>
                                        <img
                                            src="/Images/help.svg"
                                            class="ps-2"
                                            alt="Evaluation info"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title={
                                                'If any document need to attach regarding the relieving and Upload document Format should be in doc or Pdf'
                                            }
                                        />
                                    </span>
                                </label>
                                <div className="row mt-1">
                                    <div
                                        className="col-md-2 pe-0"
                                        hidden={
                                            Mode == 'Edit' || Mode == 'Trans' || attachmentState != '' || offboard.attachment.length
                                                ? true
                                                : false
                                        }
                                    >
                                        <label htmlFor="voterid-upload" className="custom-file-upload-styles">
                                            <img className="me-2" src="/Images/upload-icon.svg" alt="Upload Icon" />
                                            Upload
                                        </label>{' '}
                                    </div>
                                    <div className="col-md-7 ps-0" style={{ marginTop: '6px' }}>
                                        {bindAttach()}
                                    </div>
                                    <input
                                        id="voterid-upload"
                                        className="custom-file-upload-btn"
                                        type="file"
                                        ref={attachment}
                                        onChange={(e) => bindAttachName(e, 'off')}
                                    />
                                    <span className="ErrorMsgform" style={{ marginTop: '5px' }}>
                                        {attachmentValidation}
                                    </span>
                                </div>
                            </div>
                            
                     { ((Mode == 'Edit') && role == 'Hr Manager')||((Mode == 'Edit'))
                    //   && role == 'Hr Manager'&& initator_id==)
                      ?(<><div className="col-md-4 mb-4">
                                    <label htmlFor="bankdetails-name" className="form-label hive-form-label">
                                        Exit Reason added by HR<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="bankdetails-name"
                                        name="hr_reason_type_id"
                                        value={offboard.hr_reason_type_id?offboard.hr_reason_type_id:encryptStorage.getItem("exitbyreason")}
                                        onChange={(e) => { 
                                            OnValueChange(e); 
                                            let exitbyreason = encryptStorage.setItem("exitbyreason",e.target.value);
                                           
                                        }}
                                        disabled={
                                            (role == 'Hr Manager' || role == 'Hr') &&
                                            loggedInempId != emp_id &&
                                            inactiveTab == false
                                                ? false
                                                : true
                                        }
                                        //disabled={role == 'Team Member' || loggedInempId == emp_id ? true : Mode == 'Edit' ? true : false}
                                    >
                                        <option value={0}>Select</option>
                                        {buildReasonType()}
                                    </select>
                                    <span className="ErrorMsgform">{hrreasonValidation}</span>
                                </div>

                                <div className="col-md-12 mb-4">
                                    <label htmlFor="Drop-your-comments" className="form-label hive-form-label">
                                        Comments<span className="hive-form-mandatory"></span>
                                    </label>
                                    <textarea
                                        ref={textarearef}
                                        onBlur={() => {
                                            textarearef.current.scrollTop = 0;
                                        }}
                                        className="form-control hive-form-control"
                                        id="Drop-your-comments"
                                        name="hr_comment"
                                        value={hrcomments}
                                        rows={5}
                                        maxLength={1000}
                                        onChange={(e) => {
                                            OnValueChange(e);
                                          encryptStorage.setItem("hrcomment",e.target.value);
                                        }}
                                        placeholder="Enter the comments"
                                        // disabled={Mode == 'Edit' ? true : false}
                                        disabled={
                                            (role == 'Hr Manager' || role == 'Hr') &&
                                            loggedInempId != emp_id &&
                                            inactiveTab == false
                                                ? false
                                                : true
                                        }
                                    />
                                    {/* <span className="ErrorMsgform">{commentsValidation}</span> */}
                                </div></>):null}
                                
                        <div className="modal-footer border-0">
                            <a>
                                <button
                                    onClick={() => {
                                        cancelClickedOffboarding();
                                    }}
                                    type="button"
                                    className="btn hive-btn-secondary"
                                    data-bs-dismiss="modal"
                                    hidden={
                                        value ||
                                        Mode == 'Trans' ||
                                        (Mode == 'Edit' && role == 'Hr Manager' && loggedInempId != emp_id) ||
                                        successTemplate != 0
                                    }
                                >
                                    Cancel
                                </button>
                            </a>
                            {/* <button type="button" className="btn hive-btn-primary" onClick={() => offboardValidation()} hidden={value}>Initiate</button> */}

                            <button
                                type="button"
                                className="btn hive-btn-primary"
                                onClick={() => offboardValidation()}
                                hidden={value || Mode == 'Edit' || Mode == 'Trans'}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                    {((Mode == 'Edit' || Mode == 'Trans') && successTemplate != 0) ||
                    ((role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id && value) ||
                    (role != 'Manager' && (Mode == 'Edit' || Mode == 'Trans') && loggedInempId != emp_id) ? (
                        <div className="col-md-12 p-4 bg-white mt-4 rounded-3 mb-5">
                            <p className="font-15 tt-bold offboarding-labelcolor">
                                Transition Plan{' '}
                                <span
                                    hidden={
                                        role == 'Team Member' ||
                                        role == 'Manager' ||
                                        ((role == 'Hr Manager' || role == 'Hr') && loggedInempId == emp_id)
                                            ? false
                                            : true
                                    }
                                >
                                    {' '}
                                    - {templateName}
                                </span>
                            </p>
                            {role == 'Team Member' ||
                            role == 'Manager' ||
                            ((role == 'Hr Manager' || role == 'Hr') && loggedInempId == emp_id) ? null : (
                                <div className="mb-3 col-md-4">
                                    <label htmlFor="AssignTemplate" className="form-label hive-form-label">
                                        Assign Template <span className="required">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select regular-text font-14"
                                        id="AssignTemplate"
                                        name="assignedTemplate"
                                        value={offboard.assignedTemplate}
                                        placeholder="Select"
                                        disabled={
                                            (role == 'Hr Manager' || role == 'Hr') &&
                                            loggedInempId != emp_id &&
                                            inactiveTab == false
                                                ? false
                                                : true
                                        }
                                        onChange={(e) => OnValueChange(e)}
                                    >
                                        <option value={'0'}>Select</option>
                                        {buildTemplate()}
                                    </select>
                                    <span className="ErrorMsgform">{assignTemplateValidation}</span>
                                </div>
                            )}
                            <div className="col-md-12">
                                {successTemplate != 0 ? (
                                    <div>
                                        <ul className="offboarding-thead-backgrd list-unstyled d-flex align-items-center justify-content-between">
                                            <li>
                                                <input
                                                    className="form-check-input checkbox-sty invisible"
                                                    type="checkbox"
                                                    id="flexCheckDefault-1"
                                                />
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Work Item
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Due Date
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Responsible Person
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Action
                                            </li>
                                        </ul>
                                        {getTaskBodyInitiate()}
                                    </div>
                                ) : (
                                    <></>
                                )}
                                {template ? (
                                    <div>
                                        <ul className="offboarding-thead-backgrd list-unstyled d-flex align-items-center justify-content-between">
                                            <li>
                                                <input
                                                    className="form-check-input checkbox-sty invisible"
                                                    type="checkbox"
                                                    id="flexCheckDefault-1"
                                                />
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Work Item
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Due Date
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Responsible Person
                                            </li>
                                            <li className="align-self-center bold-text list-unstyled font-12 me-5 texthide-10 offboarding-thead-color text-truncate">
                                                Action
                                            </li>
                                        </ul>
                                        {getTaskBodyInitiate()}
                                    </div>
                                ) : (
                                    <></>
                                )}
                                <div className="d-flex justify-content-between mt-5">
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="hr-in-charge" className="form-label hive-form-label">
                                                HR in Charge<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <Select
                                                className="dropdown"
                                                name="touchbaseAttendees"
                                                maxMenuHeight={150}
                                                placeholder="Select"
                                                value={selectedPeopleList}
                                                options={showEmployee} // set list of the data
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }} // assign onChange function
                                                isClearable
                                                //isMulti
                                                isDisabled={
                                                    (role == 'Hr Manager' || role == 'Hr') &&
                                                    loggedInempId != emp_id &&
                                                    inactiveTab == false
                                                        ? false
                                                        : true
                                                }
                                            />

                                            <span className="ErrorMsgform">{hrInChargeValidation}</span>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="LastWorkingDate" className="form-label hive-form-label">
                                                Last Working Date<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control hive-form-control"
                                                id="LastWorkingDate"
                                                aria-describedby="emailHelp"
                                                name="lastWorkingDate"
                                                value={offboard.lastWorkingDate}
                                                onChange={(e) => OnValueChange(e)}
                                                disabled={
                                                    (role == 'Hr Manager' || role == 'Hr') &&
                                                    loggedInempId != emp_id &&
                                                    inactiveTab == false
                                                        ? false
                                                        : true
                                                }
                                            />
                                            <span className="ErrorMsgform">{lastDateValidation}</span>
                                        </div>
                                    </div>
                                    <div className="mb-3 col-md-4">
                                        <label htmlFor="wfh-status" className="form-label hive-form-label">
                                            Status
                                            <span>
                                                <img
                                                    src="/Images/help.svg"
                                                    class="ps-2"
                                                    alt="Evaluation info"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={'The status will be changed after reviewing the tasks by Responsible HR'}
                                                />
                                            </span>
                                        </label>
                                        <select
                                            className="form-select hive-form-select"
                                            id="wfh-status"
                                            name="status"
                                            value={offboard.status}
                                            onChange={(e) => OnValueChange(e)}
                                            disabled={encryptStorage.getItem('groupid')=== '2'|| Mode !== 'Edit'}
                                            // disabled={
                                            //     inactiveTab
                                            //         ? true
                                            //         : activeVariable == true &&
                                            //           (role == 'Hr Manager' || role == 'Hr') &&
                                            //           loggedInempId != emp_id
                                            //         ? false
                                            //         : true
                                            //}
                                            // activeVariable == true && ((role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id)
                                            // disabled={((activeVariable == true && inactiveTab == false) && ((role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id)) || inactiveTab  ? false : true}
                                        >
                                            <option disabled>Select</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="text-end d-flex justify-content-end my-3">
                                    <a>
                                        {/* href={role == 'Team Member' ? `/profilecontainer?EmpId=${emp_id}&tab=Offboard` : '/HrOffboardingGrid'} */}
                                        <button
                                            onClick={() => {
                                                cancelClickedOffboarding();
                                            }}
                                            className="btn hive-btn-secondary me-3"
                                        >
                                            Cancel
                                        </button>
                                    </a>
                                    {successTemplate != 0 ? (
                                        <button
                                            className="btn hive-btn-primary"
                                            onClick={() => validationInitiate('save')}
                                            disabled={
                                                (role == 'Hr Manager' || role == 'Hr') && loggedInempId != emp_id && !disabledCheck
                                                    ? false
                                                    : true
                                            }
                                            hidden={encryptStorage.getItem('groupid') === '2' }
                                        
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            className="btn hive-btn-primary"
                                            onClick={() => validationInitiate('initiate')}
                                             disabled={disableInitiate}
                                        >
                                            Initiate
                                        </button>
                                    )}
                                </div>
                                {/*Form structure ends Here*/}
                            </div>
                        </div>
                    ) : null}

                    {/*Form structure ends Here*/}
                </div>

                {/* for the task pop up */}
                <div
                    className="modal fade show pop-bg "
                    id="exampleModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-modal="true"
                    role="dialog"
                    style={{ display: 'block' }}
                    hidden={transitionPopUp == true ? true : false}
                >
                    <div className="modal-dialog Offboard-popup-width modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="align-items-center justify-content-inbetween">
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <p className=" font-15 tt-bold mb-0 d-flex me-3">Offboarding for</p>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src="/Images/logo-person-user-person-icon.jpg"
                                                        className="offboarding-user-profile"
                                                        alt="UserImage"
                                                    />
                                                    <div>
                                                        <a href="#" className="font-12 semibold-text mb-0 text-decoration-none">
                                                            {employeeName}
                                                        </a>
                                                        <p className=" font-13 regular-text mb-0">{employeeDomain}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    onClick={() => cancelClicked()}
                                                />
                                            </div>
                                        </div>
                                        <p className="mt-3 mb-4 bold-text font-16">
                                            <span
                                                style={{ paddingBottom: '3px', paddingRight: '2px' }}
                                                hidden={popup.status == 'InComplete' ? false : true}
                                            >
                                                <img src="/Images/offboarding-checked.svg" />
                                            </span>
                                            {popup.templateName}
                                        </p>
                                        <div className="d-flex">
                                            <p className="font-14 regular-text offboardingpop-grey-font mb-4">
                                                Due on <span className="offboardingpop-black-font">: {popup.dueDate}</span>
                                            </p>
                                            <p className="ms-5 mb-0 regular-text offboardingpop-grey-font font-14">
                                                Responsible
                                                <span className="offboardingpop-black-font">: @{popup.responsiblePerson?.username}</span>
                                            </p>
                                        </div>
                                        <label
                                            className="form-label hive-form-label w-100 font-12 semibold-text"
                                            hidden={(attachmentPopUp && attachmentState != null) || popup.att != null ? true : false}
                                        >
                                            Attachment{' '}
                                            <span>
                                                <img
                                                    src="/Images/help.svg"
                                                    class="ps-2"
                                                    alt="Evaluation info"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={`Upload document in doc or Pdf format`}
                                                />
                                            </span>
                                        </label>
                                        <div
                                            hidden={
                                                (attachmentPopUp && attachmentState != null) ||
                                                popup.att != null ||
                                                attachmentValidationTrans != ''
                                                    ? true
                                                    : false
                                            }
                                            className="mb-3"
                                        >
                                            <label htmlFor="transAttachment" className="custom-file-upload-styles">
                                                <img className="me-2" src="/Images/upload-icon.svg" alt="Upload Icon" />
                                                Upload
                                            </label>
                                        </div>
                                        <div className="col-md-7 ps-0" style={{ marginTop: '6px' }}>
                                            {bindAttachTrans()}
                                        </div>
                                        <input
                                            id="transAttachment"
                                            className="custom-file-upload-btn "
                                            type="file"
                                            //  onClick={FileUpload()}
                                            ref={attachment1}
                                            onChange={(e) => bindAttachName(e, 'trans')}
                                        />
                                        <span className="ErrorMsgform" style={{ margin: '10px 0px' }}>
                                            {attachmentValidationTrans}
                                        </span>
                                        <div>
                                            <p className="offboardingpop-grey-font mb-4 font-12 medium-text">
                                                <span>
                                                    <img src="/Images/information-button.svg" alt="Infor" />
                                                </span>
                                                Take some time to give feedback to your manager and team before leaving them.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center d-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn hive-btn-secondary bold-text font-14 me-3"
                                        onClick={() => cancelClicked()}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn hive-btn-primary bold-text font-14"
                                        type="submit"
                                        onClick={() => individualTaskUpdate()}
                                    >
                                        Mark as {popup.status}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Failure-PopUp pop-bg" hidden={deletePopUp == true ? true : false}>
                    <div className="modal-dialog goal-popup modal-dialog-centered">
                        <div className="modal-content px-5">
                            <div className="modal-body text-center px-5 py-4">
                                <p className="bold-text font-18 text-blue my-5">Are you sure do you want to delete the Task? </p>
                                <div className="text-center d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="btn hive-btn-secondary bold-text font-14 me-3"
                                        onClick={() => cancelClickedDelete()}
                                    >
                                        No,Check Again
                                    </button>
                                    <button className="btn hive-btn-primary bold-text font-14" type="submit" onClick={() => yesClicked()}>
                                        Yes Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
            </div>
        </>
    );
};

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(Offboarding);

